import React from 'react'
import ContentLoader from '../components/content-loader/content-loader'
import Login from '../components/login/login.component'

const LoginPage = () => (
  <>
    <Login />
    <ContentLoader />
  </>
)

export default LoginPage
